/**
 * Created by katarinababic on 11.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { WeekDayEntryEvent } from '../../Model/Coach/Schedule/WeekDayEntryEvent';
import { WorkoutDayCardEventHealthDataPoint } from './WorkoutDayCardEventHealthDataPoint';
import { WorkoutDayCardEventExploreEntry } from './WorkoutDayCardEventExploreEntry';

export type WorkoutDayCardEventProps = {
  entry: WeekDayEntryEvent;
};

export const WorkoutDayCardEvent: React.FC<WorkoutDayCardEventProps> = observer(({ entry }) => {
  if (entry.event.objectType === 'healthDataPoint') {
    return <WorkoutDayCardEventHealthDataPoint entry={entry} />;
  }

  return <WorkoutDayCardEventExploreEntry entry={entry} />;
});
